export default function analyzeLink(url: string, query?: Record<string, string>): string {
  let uri = "";
  let resUrl = "";
  // 解析地址栏，获取活动id
  const searchParams = new URLSearchParams(location.search);
  const activityId = searchParams.get("activityId");
  const activityRuleId = searchParams.get("activityRuleId");
  let search = "";
  if (Number(url)) {
    // 页面id自己拼接成完整链接
    uri = location.origin + (location.pathname.length > 1 ? location.pathname : "");
    search = `?id=${url}`;
  } else {
    // 正常链接
    try {
      const urlObj = new URL(url);
      uri = urlObj.origin + (urlObj.pathname.length > 1 ? urlObj.pathname : "");
      search = urlObj.search;
    } catch (error) {
      // console.log(error);
      return "";
    }
  }
  if (query) {
    Object.keys(query).forEach((key) => {
      search += `${search ? "&" : "?"}${key}=${query[key]}`;
    });
  }
  if (activityId) {
    search += `${search ? "&" : "?"}activityId=${activityId}`;
  }
  if (activityRuleId) {
    search += `${search ? "&" : "?"}activityRuleId=${activityRuleId}`;
  }
  resUrl += uri + search;
  return resUrl;
}
